import { InjectionToken } from '@angular/core';
import { ICreateClientParams } from './models/contentful.model';

/**
 * Token for Dependency Injection.
 * Should be used to provide the contentful configuration at the
 * app initialization level.
 */
export const CONTENTFUL_CONFIG = new InjectionToken<ICreateClientParams>(
  'CONTENTFUL_CONFIG'
);
